module.exports = __webpack_public_path__ + "img/beauty_qr_code.8a2eedb5.png";